import * as Sentry from '@sentry/browser';

const dataset = document.getElementById('sentry-script')?.dataset;
if (!dataset || !dataset.dsn || !dataset.env) {
	console.error('Sentry not initialized - missing dataset');
} else {
	try {
		Sentry.init({
			dsn: dataset.dsn,
			integrations: [Sentry.browserTracingIntegration(), Sentry.httpContextIntegration()],
			tracesSampleRate: 0.0,
			replaysOnErrorSampleRate: 0,
			replaysSessionSampleRate: 0,
			environment: dataset.env,
			sendDefaultPii: true,
		});
	} catch (e) {
		console.error(e);
	}
}
